<template>
  <v-autocomplete
    v-model="addModel"
    :items="items"
    item-text="name"
    item-value="id"
    :search-input.sync="search"
    hide-selected
    hide-details=""
    v-on:change="OnAttributeSelected"
    v-on:focus="OnAttributeFocus"
    :label="label"
    chips=""
    :multiple="multiple"
    :clearable="clearable"
    :deletable-chips="multiple"
    dense
    return-object
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title v-if="isLoaded">
            No results matching "<strong>{{ search }}</strong
            >".
          </v-list-item-title>
          <v-progress-circular
            style="pointer-events:none"
            indeterminate=""
            v-else
          ></v-progress-circular>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AttributeSearch",
  props: {
    //Dialog to attach for edit events
    attachedDialog: {
      default: null,
      type: Boolean,
    },
    //Label to show above attribute search
    label: {
      default: "Add attribute",
      type: String,
    },
    //Show clear option at end of input
    clearResult: {
      default: true,
      type: Boolean,
    },
    //Allow for multiple selections
    multiple: {
      default: false,
      type: Boolean,
    },
    //Show clear option at end of input
    clearable: {
      default: false,
      type: Boolean,
    },
    //Inital selected values
    initalValues: {
      default: null,
      type: Array,
    },
  },
  computed: {},
  data: () => ({
    items: [
      {
        id: "1",
        name: "aname",
      },
      {
        id: "2",
        name: "second atb",
      },
    ],
    addModel: "",
    search: "",
    changed: false,
    isLoaded: false,
  }),
  methods: {
    ...mapActions("assetxpstate", ["GetAllAttributes"]),
    OnAttributeSelected(attribute) {
      this.changed = true;

      this.$emit("AttributeSelected", attribute);

      if (this.clearResult) {
        this.$nextTick(() => {
          this.addModel = "";
          this.search = "";
        });
      }
    },
    OnAttributeFocus() {
      //this.isLoaded = true;

      if (!this.isLoaded) {
        this.GetAllAttributes().then((data) => {
          this.items = data;
          this.isLoaded = true;
          console.log("Got items", data);
        });
      }
    },
  },
  watch: {
    attachedDialog: {
      handler(newVal) {
        if (newVal) {
          this.addModel = "";
        }
      },
    },
    initalValues: {
      immediate: true,
      handler(newVal) {
        if (this.initalValues != null) {
          if (this.multiple) {
            var valuesWithoutNames = this.initalValues.filter((el) => {
              return el.name == null;
            });

            if (valuesWithoutNames.length > 1) {
              this.GetAllAttributes().then((data) => {
                this.items = data;
                this.isLoaded = true;

                this.initalValues.forEach((value, index) => {
                  var matchedId = data.filter((el) => {
                    return el.id == value.id;
                  });

                  if (matchedId.length > 0) {
                    this.initalValues[index] = matchedId[0];
                  }
                });
              });
            }

            this.addModel = this.initalValues;
          } else {
            if (this.initalValues.name == null) {
              if (!this.isLoaded) {
                this.GetAllAttributes().then((data) => {
                  this.items = data;
                  this.isLoaded = true;

                  var matchedId = data.filter(function(el) {
                    return el.id == newVal.id;
                  });

                  if (matchedId.length > 0) {
                    this.addModel = matchedId[0];
                  }
                });
              }
            }
          }
        }

        this.addModel = this.initalValues;
      },
    },
  },
};
</script>

<style></style>
